"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortTableRows = void 0;
var tslib_1 = require("tslib");
var typings_1 = require("Views/Partials/Components/TableCore/typings");
var sortTableRows = function (rows, sortOrder, sortColumn) {
    var sortStrings = function (rowOne, rowTwo) {
        return sortOrder === typings_1.OrderTypeEnum.Ascending
            ? rowOne[sortColumn].localeCompare(rowTwo[sortColumn])
            : rowTwo[sortColumn].localeCompare(rowOne[sortColumn]);
    };
    return tslib_1.__spreadArray([], rows, true).sort(sortStrings);
};
exports.sortTableRows = sortTableRows;
